/**
 *  HTTP CONSTANTS
 */
// URL di base Web Service
export const WS_BASE_URL = "/ProtocolloLegalita/api/"                                    //DYNAMIC MODIFICA PER SERVER MM 25/02/2021

// export const WS_INTERNAL_URL = "http://192.168.5.192:8081" //PATH COLLAUDO
export const WS_INTERNAL_URL = "http://192.168.5.192:8090" //PATH SVIL, modifiche 29/04/2024

// Timeout richieste POST
export const REQUEST_TIMEOUT = 240000;

// Tentativi richieste POSTS
export const REQUEST_RETRIES = 3;

//APP VERSION
export const APP_VERSION = "2.9.1"

/*
*   LOCAL STORAGE KEY
*/
export const LS_USER_GUID = "USER_GUID"
export const LS_USER_TYPE = "USER_TYPE"
export const LS_USER_ROLE = "USER_ROLE"
export const LS_USERNAME = "USERNAME"
export const LS_PASSWORD = "PASSWORD"
export const LS_ESECUTORE = "ESECUTORE"
export const LS_AGGIUDICATARIO = "AGGIUDICATARIO"
export const LS_RAG_SOCIALE = "RAGIONE_SOCIALE"

/**
 * header for upload file
 */
export const NUMERO_ALLEGATO = "NUMERO_ALLEGATO"
export const STORICOMODULO_ID = "STORICOMODULO_ID"
export const NOME_FILE = "NOME_FILE"
export const PAGAMENTO_ID = "PAGAMENTO_ID"
export const SAL_ID = "SAL_ID"
export const AZIENDA_ID = "AZIENDA_ID"
export const STATO_ANTIMAFIA = "STATO_ANTIMAFIA"
export const DESCRIZIONE_ALLEGATO = "DESCRIZIONE_ALLEGATO"
export const ID_COMMESSA = "ID_COMMESSA"
export const ALLEGATO_ID = "ALLEGATO_ID"

//LOGIN URL
export const URL_LOGIN = "auth/login"

//RICHIESTA CONTRATTO
export const TIPO_RICHIESTA_CONTRATTO_COMMESSA = "Contratto Commessa"
export const TIPO_RICHIESTA_CONTRATTO_CANTIERE = "Contratto Cantiere"
export const TIPO_CONTRATTO = "Gestione Contratto"
export const TIPO_RICHIESTA_CONTRATTO_ESECUTORE = "Gestione Esecutore"
export const TIPO_RICHIESTA_SUBAFFIDAMENTO = "Subaffidamento"
export const TIPO_RICHIESTA_SUBAPPALTO = "Subappalto"
export const TIPO_RICHIESTA_SUBAPPALTO_SERVIZI = "Subappalto di servizi"
export const TIPO_RICHIESTA_VERIFICA_ANTIMAFIA = "Verifica Antimafia"
export const TIPO_RICHIESTA_CONTRATTO_AFFIDATARIA = "Contratto Affidataria"

//RICHIESTE MEZZI/PERSONE

export const TIPO_INTEGRAZIONE_MEZZI = "Integrazione Mezzi"
export const TIPO_INTEGRAZIONE_PERSONE = "Integrazione Persone"


//STATO ANTIMAFIA
export const STATI_ANTIMAFIA = [
    { label: 'In corso verifica documentazione', value: 'In corso verifica documentazione' },
    { label: 'Documentazione verificata', value: 'Documentazione verificata' },
    { label: 'Inserita in BDNA', value: 'Inserita in BDNA' },
    { label: 'Esito Positivo', value: 'Esito Positivo' },
    { label: 'Esito Negativo', value: 'Esito Negativo' },
    { label: 'Liberatoria provvisoria', value: 'Liberatoria provvisoria' },
    { label: 'Iscr. WL Verificata', value: 'Iscr. WL Verificata' },
    { label: 'Iscr. WL In Aggiornamento', value: 'Iscr. WL In Aggiornamento' },
    { label: 'Pratica in Istruttoria', value: 'Pratica in Istruttoria' }

]

export const ACCESSI_BLOCK = {
    START: 18,
    END: 7
}